<template>
  <div>
    <plan-money-back :id="id" ref="planMoneyBack"/>
    <div class="return-record-info">
<!--      <crm-button-->
<!--        v-if="-->
<!--                  contractAuth.exportPayBack && contractAuth.exportPayBack.toggleStatus-->
<!--                "-->
<!--        :buttonType="'plain'"-->
<!--        :size="'mini'"-->
<!--        :text="'导出'"-->
<!--        :disabled="isDownload"-->
<!--        class="fr mb10"-->
<!--        @click="handleExportReturnRecord"-->
<!--      >-->
<!--      </crm-button>-->
      <crm-button
        v-if="contractAuth.addPayBack && contractAuth.addPayBack.toggleStatus"
        :size="'mini'"
        :text="'新增收款记录'"
        class="fr mb10 mt10"
        @click="handleAddReturnRecord"
      >
      </crm-button>
    </div>
    <el-table
      :data="returndRecord.results"
      :loading="returnLoading"
      style="width: 100%; height: calc(50vh - 205px);"
      height="calc(50vh - 205px)"
    >
      <el-table-column prop="refundInstallment" label="期数" align="center"/>
      <el-table-column prop="refundType" label="回款类型" align="center"/>
      <el-table-column prop="planRefundAmount" label="计划回款金额（元）" align="center" width="150px"/>
      <el-table-column prop="planRefundDateStr" label="计划回款日期" align="center" width="150px"/>
      <el-table-column prop="refundAmount" label="实际回款金额（元）" align="center" width="150px"/>
      <el-table-column prop="refundDate" label="实际回款日期" align="center" width="150px"/>
      <el-table-column prop="examineStatus" label="状态" align="center"/>
      <el-table-column
            prop=""
            label="回单"
            align="center"
            width="150px"
            :show-overflow-tooltip="true"
        >
        <template #default="{row}">
            <el-button v-if="row.receiptLink" type="text" @click="handlePreviewUrl(row.receiptLink)">回单</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="myReceivableCompany" label="我方收款公司" align="center" width="150px"/>
      <el-table-column prop="myReceivableBank" label="我方收款银行" align="center" width="150px"/>
      <el-table-column prop="myReceivableAccount" label="我方收款账号" align="center" width="150px"/>
      <el-table-column prop="minimumBudgetUnit" label="最小预算单元" align="center" width="150px"/>
      <el-table-column prop="businessAccountDept" label="业务结算部门" align="center" width="150px"/>
      <el-table-column prop="firstAccountDept" label="一级结算部门" align="center" width="150px"/>
      <el-table-column prop="remark" label="备注" align="center"/>
      <el-table-column prop="fileList" label="附件" align="center" width="150px">
        <template slot-scope="scope">
          <div v-for="fileObj in scope.row.fileList" :key="fileObj.fileId">
            <a href="javascript:;" @click="getFildUrl(fileObj)">
              {{ fileObj.fileName  }}
            </a>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150px">
        <template slot-scope="scope">
          <el-button
            v-if="
                      contractAuth.updatePayBack &&
                      contractAuth.updatePayBack.toggleStatus
                    "
            @click="handleEditPayback(scope)"
            type="text"
            size="small"
            :disabled="scope.row.examineStatus !== '待确认'"
          >
            编辑
          </el-button>
          <el-button
            v-if="
                      contractAuth.deletePayback &&
                      contractAuth.deletePayback.toggleStatus
                    "
            @click="handleDeleteReturnRecord(scope)"
            type="text"
            size="small"
            :disabled="scope.row.examineStatus !== '待确认'"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="returndRecord.pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="returndRecord.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="returndRecord.totalCount"
      >
      </el-pagination>
    </div>
    <!-- 新增、编辑、查看回款明细弹窗 -->
    <payback-dialog
      ref="paybackRef"
      :row="row"
      :id="id"
      :info="info"
      @handle-success-payback="queryList"
    />
    <!-- 回款详情 -->
    <payback-detail ref="paybackDetailRef" />
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
    <pdf-view ref="pdfView"/>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions, mapGetters } from 'vuex'
import { newDownloadByUrl } from '@/scripts/utils'
import paybackDialog from "./paybackDialog.vue";
import paybackDetail from "./payback-detail";
import PlanMoneyBack from './planMoneyBack';
import pdfView from "@/components/base/pdf-view";

export default {
  components: {
    CrmButton,
    paybackDialog,
    paybackDetail,
    PlanMoneyBack,
    pdfView,
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  filters: {},
  props: {
    id: String,
    info: Object,
  },
  data() {
    return {
      isDownload: false,
      returnLoading: false,
      row: {},
      returnRecord: {
        pageNumber: 1,
        pageSize: 5,
      },
      imagePreview: {
        showImage: false,
        url: "",
      },
    }
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      compactDetail: "compact/compactDetail",
      returndRecord: "compact/returndRecord",
    }),
  },
  watch: {},
  methods: {
    ...mapActions({
      getReturndRecord: "compact/getReturndRecord",
      deletePaybackRecord: "compact/deletePaybackRecord",
    }),
    handleSizeChange(value) {
      this.returnRecord.pageSize = value
      this.returnRecord.pageNumber = 1
      this.queryList()
    },
    handleCurrentChange(value) {
      this.returnRecord.pageNumber = value
      this.queryList()
    },
    handleExport() {},
    // 导出回款记录
    async handleExportReturnRecord() {
      const url = `/api/receivableManagement/export?contractId=${this.id}`;
      this.handleDownloadRecord(url);
    },
    async handleDownloadRecord(url) {
      try {
        this.isDownload = true;
        this.notify = this.$notify({
          iconClass: "el-icon-loading",
          title: "",
          message: "正在导出中，请稍后...",
          duration: 0,
          showClose: false,
        });
        await newDownloadByUrl(url);
        this.notify.close();
      } catch (error) {
        this.notify.close();
        this.$message.error(error.message);
      }
      this.isDownload = false;
    },
    // 打开新增回款记录窗口
    handleAddReturnRecord() {
      this.$refs.paybackRef.handleOpen();
    },
    // 编辑回款
    handleEditPayback({ row }) {
      this.$refs.paybackRef.handleEdit(row);
    },
    // 删除回款记录
    handleDeleteReturnRecord(scope) {
      this.$confirm("是否确定删除该记录？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deletePaybackRecord({ idList: [scope.row.id] }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.isRefresh = true;
            this.queryList();
          });
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 查看回款详情
    handleGetDetail({ row }) {
      this.$refs.paybackDetailRef.handleOpenDetail(row.id);
    },
    queryList() {
      this.returnLoading = true;
      const { pageNumber, pageSize } = this.returnRecord;
      this.getReturndRecord({
        contractId: this.id,
        pageNumber,
        pageSize,
      }).finally(() => {
        this.returnLoading = false;
      });
      this.$refs.planMoneyBack.handleQueryList()
    },
    // 回款记录
    handleFormatterRefundInstallment(row) {
      return row.refundInstallment === 0 ? "--" : row.refundInstallment;
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    handlePreviewUrl(url) {
        this.$refs.pdfView.open(url)
    },
  },
}
</script>
